function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "ICONS/FIGURES/ico-30-porte-fenetre");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Symbols",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", {
  id: "ICONS/FIGURES/ico-30-porte-fenetre",
  fill: "#000000"
}, /*#__PURE__*/React.createElement("path", {
  d: "M1,8 C8.62750019,8 14.8303269,14.0997524 14.996578,21.687355 L15,21.999 L1,22 L1,8 L1,8 Z M29,8 L29,22 L15,21.999 L15.003422,21.687355 C15.1696731,14.0997524 21.3724998,8 29,8 Z",
  id: "Combined-Shape"
})));

const SvgIco30PorteFenetre = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "30px",
  height: "30px",
  viewBox: "0 0 30 30",
  ref: svgRef
}, props), title === undefined ? _ref : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgIco30PorteFenetre, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/ico-30-porte-fenetre.6e3078cc.svg";
export { ForwardRef as ReactComponent };